/* Built In Imports */
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box, Image } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import MidContainer from '@Layout/MidContainer';
import PageConfig from '@msr/Common/PageConfig';
import WrapLayout from '@msr/components/Layout/WrapLayout';
import Breadcrum from '@msr/components/Navigation/Breadcrum';
import StructuredTextContent from '@msr/components/UI/StructuredTextContent';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@msr/components/Utility/Shared/SharedService';
import {
    fetchFooterDetailData,
    fetchHeaderMenuData
} from 'services/commonService';
import { fetchDetails } from 'services/msrService';

/**
 *
 * @param {Object} pageData
 * @returns
 */
const StoryOfNayanmars = ({ pageData }) => {
  const authContext = useContext(AuthContext);
  const router = useRouter();

  const embedObj = {
    embedUrl: pageData?.videoUrl,
    source: 'youtube'
  };

  useEffect(() => {
    authContext.RegionAndLang('', 'en');
  }, [authContext, '', 'en']);

  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={''}
        lang={'en'}
      />
      <Box
        as="section"
        className="container-article"
        p="0"
        pt="64px"
        bg="#FFF7E9"
      >
        <MidContainer w={'758'}>
          <Image
            src={pageData?.heroImage?.url}
            title={pageData?.heroImage?.title}
            alt={pageData?.heroImage?.alt}
            width="100%"
            height={{ base: '215px', lg: '454px' }}
            objectFit="cover"
          />
        </MidContainer>
        <MidContainer w={{ base: '90%', lg: '592px' }}>
          <Box
            fontSize={{ base: '36px', lg: '40px' }}
            lineHeight="48px"
            textAlign="center"
            fontFamily="FedraSerifAStdBook"
            mt={{ base: '40px', lg: '60px' }}
            mb="20px"
            as="h1"
            fontWeight="600"
          >
            {pageData.title}
          </Box>
          <Box
            fontFamily="FedraSansStd-book"
            fontSize="16px"
            textAlign="left"
            mb="43px"
          >
            {pageData.summary}
          </Box>
        </MidContainer>
        <MidContainer w={'758'}>
          <Box
            fontFamily="FedraSansStd-book"
            className="structured-content-dark"
            fontSize="16px"
            p={{ base: "0 15px", md: "0" }}
          >
            {StructuredTextContent(pageData.body)}
          </Box>
        </MidContainer>
        <PageConfig
          isLikeVisible={false}
          pageData={pageData}
        />
      </Box>
    </WrapLayout>
  );
};

export const getStaticProps = async ({ preview, previewData }) => {
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('IN', 'en'),
    'msrmainmenu'
  );
  const footerData = await fetchFooterDetailData(
    getLocale('IN', 'en'),
    'msrfooter'
  );
  const pageData = await fetchDetails('', '', `shiva/story-of-nayanmars`, {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerMenuData: headerMenuData?.data || null,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      menuType: 'msrmainmenu'
    }
  };
};

export default StoryOfNayanmars;
